
import React, { useState } from "react";

import { FontAwesomeIcon }
    from "@fortawesome/react-fontawesome";

import {
    OMNISCAN_BLUE_SOFT
} from "../constants/colors";


//========================================================
// OMNISCAN PRO
// LEFT MENU ICON
//
// Standardised OmniScan brand colours.
//
// Selected and hovered icons use OMNISCAN_BLUE.
// Selected marker uses translucent OMNISCAN_BLUE.
//========================================================

export default function LeftMenuIcon({
    id,
    icon,
    clickFunction,
    highlightId,
    label
})
{

    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [isHover, setIsHover] =
        useState(false);


    //--------------------------------------------------------
    // Selected
    //--------------------------------------------------------

    const isSelected =
        id === highlightId;


    //--------------------------------------------------------
    // Container
    //--------------------------------------------------------

    const thisContainer =
    {
        display: "flex",

        width: "60px",
        height: "76px",

        alignItems: "center",
        justifyContent: "center",

        flexDirection: "column",

        cursor: "pointer",

        position: "relative",

        margin: "0",

        borderBottom:
            "1px solid rgba(255,255,255,0.14)",

        transition:
            "background 0.2s ease"
    };


    //--------------------------------------------------------
    // Icon wrapper
    //--------------------------------------------------------

    const iconWrapper =
    {
        width: "42px",
        height: "34px",

        display: "flex",

        alignItems: "center",
        justifyContent: "center",

        position: "relative"
    };


    //--------------------------------------------------------
    // Icon
    //--------------------------------------------------------

    const iconStyle =
    {
        width: "19px",
        height: "19px",

		color:
		    isSelected || isHover
		        ? OMNISCAN_BLUE_SOFT
		        : "rgba(255,255,255,0.82)",

        transition:
            "color 0.2s ease"
    };


    //--------------------------------------------------------
    // Label
    //--------------------------------------------------------

    const labelStyle =
    {
        marginTop: "5px",

        fontSize: "9px",

        fontWeight: "500",

        letterSpacing: "0.3px",

        color:
            isSelected
                ? "#ffffff"
                : isHover
                    ? "#ffffff"
                    : "rgba(255,255,255,0.62)",

        transition:
            "color 0.2s ease"
    };


    //--------------------------------------------------------
    // Selected marker
    //--------------------------------------------------------

    const selectedMarker =
    {
        position: "absolute",

        left: "0",
        top: "19px",

        width: "2px",
        height: "38px",

		background:
		    OMNISCAN_BLUE_SOFT,

        opacity:
            isSelected
                ? 1
                : 0,

        transition:
            "opacity 0.2s ease"
    };


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div

            style={thisContainer}

            onMouseEnter={
                () => setIsHover(true)
            }

            onMouseLeave={
                () => setIsHover(false)
            }

            onClick={clickFunction}

        >

            <div style={selectedMarker} />


            <div style={iconWrapper}>

                <FontAwesomeIcon
                    icon={icon}
                    style={iconStyle}
                />

            </div>


            <div style={labelStyle}>

                {label}

            </div>

        </div>

    );

}
